import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewDocumentTypeModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewDocumentTypeModal: React.FC<ViewDocumentTypeModalProps> = ({ open, onClose }) => {
  const { selectedDocumentType, loading } = useAppSelector((state) => state.documentTypes);

  if (!selectedDocumentType && !loading) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ver Tipo de Documento</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedDocumentType ? (
          <Box sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="ID"
              value={selectedDocumentType.id}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Código"
              value={selectedDocumentType.code}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Nombre"
              value={selectedDocumentType.name}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Descripción"
              value={selectedDocumentType.description}
              margin="normal"
              multiline
              rows={3}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Chunk Size"
              value={selectedDocumentType.chunkSize}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Chunk Overlap"
              value={selectedDocumentType.chunkOverlap}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Creado el"
              value={selectedDocumentType.createdAt}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Creado por"
              value={selectedDocumentType.createdBy}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Box>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewDocumentTypeModal;
